import React, { useEffect } from 'react';
import { bool } from 'prop-types';
import { Modal, Button, Skeleton, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectForm } from '@redux/forms/reducers';
import { fetchForms } from '@redux/forms/actions';
import TranslatedForm from '@components/TranslatedForm';
import './style.less';

const FormPreviewModal = ({
  readOnly,
  schema,
  uiSchema,
  visible,
  handleCloseModal,
  name,
  loading,
  submitting,
  children,
  hideCloseFooter,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      className="form-preview-modal"
      title={name}
      visible={visible}
      onCancel={handleCloseModal}
      centered
      footer={
        hideCloseFooter
          ? null
          : [
              <Button type="primary" onClick={handleCloseModal}>
                {t('cards:FormContent.modalButton')}
              </Button>,
            ]
      }
    >
      {loading ? (
        <Skeleton />
      ) : (
        <Spin spinning={submitting}>
          <TranslatedForm schema={schema} uiSchema={uiSchema} namespace="forms" {...props}>
            {readOnly ? <div></div> : children}
          </TranslatedForm>
        </Spin>
      )}
    </Modal>
  );
};

FormPreviewModal.propTypes = {
  submitting: bool,
};

FormPreviewModal.defaultProps = {
  submitting: false,
};

export const FormPreviewModalById = ({ formId, children, ...props }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchForms());
  }, [dispatch, formId]);

  const [loading, form] = useSelector(selectForm(formId));

  return (
    <FormPreviewModal
      loading={loading}
      schema={form?.latestVersion?.schema ?? {}}
      uiSchema={(form?.latestVersion?.uiSchema || form?.latestVersion?.ui_schema) ?? {}}
      {...props}
    >
      {children}
    </FormPreviewModal>
  );
};

export default FormPreviewModal;
